class menuMb {
  constructor(btnBurger) {
    this.burgerMenu = btnBurger;
    this.navbar = document.querySelector("#logo-centered-nav");
    this.body = document.querySelector("body");
    this.events();
  }

  events() {
    this.burgerMenu.addEventListener("click", () => this.toggleTheMenu());
  }

  toggleTheMenu() {
    this.burgerMenu.classList.toggle("is-open");
    this.navbar.classList.toggle("is-open");
    this.body.classList.toggle("burger-open");
    // this.burgerMenu.classList.toggle('burger-mb--close-x');
  }
}

const btnBurger = document.querySelector(".burger-mb");
if (btnBurger) {
  new menuMb(btnBurger);
}
